<div class="sort_by option_container"
  [class.from_all]="fromAllFiltration"
>

  <div *ngFor="let item of sorting" class="options">
    <label class="radio" (click)="onSortChange(item.id)">
      <input type="radio" class="pointer" name="price"
             [value]="item.id"
             [checked]="selectedId === item.id"
             [ngClass]="{'checked': item.id === selectedId}"
      >
      <span class="checkmark without_border" [ngClass]="{'checked': item.id === selectedId}">
          <img src="assets/images/icons/checkbox_icon.svg">
        </span>
      <div class="label_title text_normal_sub bold_500 pointer"
           [ngClass]="{'bold_700' : item.id === selectedId}"
      >
        {{ 'sort_by.sort_by' | translate }} {{ ('sort_by.' + item.text) | translate }}
      </div>
    </label>
  </div>
</div>
